<template>
  <div>
    <div class="main contarner">
      <div class="onefloor">
        <div class="onefloor-left">
          <div class="rate">
            <div>Exchange Rate</div>
            <div class="dateday">{{ dibu.english_time }}</div>
          </div>
          <div class="usd">1(USD)={{ usd }}(RMB)</div>

          <!-- 线图 -->
          <div class="ification">
            <span :class="{ ficat: i == 1 }" @mouseover="i = 1">FOR HERBICIDE</span>
            <span :class="{ ficat: i == 2 }" @mouseover="i = 2">FOR INSECTICIDE</span>
            <span :class="{ ficat: i == 3 }" @mouseover="i = 3">FOR FUNGICIDE</span>
          </div>

          <div class="echarsa">
            <div class="sxl_tis" style="margin-top: 10px;margin-bottom: 10px;">Price Trend</div>
            <div class="echarsa-tiem" :class="i == v ? 'echarsa-tiem-on' : ''" v-for="(v, j) in [1, 2, 3]"
              :key="j + 'ech'">
              <div class="echar" ref="Echar"></div>
              <div style="text-align: center;">{{ quxian[j] ? quxian[j].product_name : "" }}</div>
            </div>
          </div>

          <!-- 新闻 -->
          <div class="newss_warp">
            <div class="sxl_tis" style="margin-top: 40px;">Product News</div>
            <router-link to="/frontend/goods/products" class="more">MORE</router-link>
          </div>
          <div class="new_list">
            <template v-for="(item, index) in newsList">
              <router-link :to="'/frontend/news/detail?id=' + item.id" v-if="index < 5" :key="index">
                <h5 class="span">{{ item.pro_title }}</h5>
                <div class="text">
                  <h6>{{ item.title }}</h6>
                  <span>{{ item.posttime }}</span>
                </div>
              </router-link>
            </template>
          </div>

        </div>

        <div class="onefloor-right">
          <div class="rightop">
            <div class="name">
              <span>Name of Product</span>
            </div>
            <div class="price">
              <span>Updated Price</span>
            </div>
            <div class="trend">
              <span>Price Trend</span>
            </div>
          </div>
          <vue-seamless-scroll :data="listData" :class-option="classOption" class="rightmain"
            :style="{ height: (hhh - 50 + 'px'), marginTop: '10px' }">
            <ul v-if="listData.length > 0">
              <li v-for="(i, index) in listData" :key="index">
                <div class="names">
                  <div>
                    <router-link :to="`/frontend/goods/products/detail?id=${i.id}&name=${i.product_name}`">{{
              i.product_name }}</router-link>
                  </div>
                  <div>{{ i.serial_number }}</div>
                </div>
                <div class="jiage">${{ i.updated_price }}</div>
                <!-- require('@/assets/img/xia.png') -->
                <div class="bili">
                  <img :src="i.price_trend == 2
              ? require('@/assets/img/shang.png')
              : require('@/assets/img/xia.png')
              " />
                </div>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>

      <div class="twofloor" v-if="guangao.length">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(v, i) in guangao" :key="i + 'guang'">
            <!-- <router-link :to="'/frontend/goods/factoryDetail?id='+v.manufacturer_id"> -->
            <router-link to="/frontend/about/us?pid=2">
              <img :src="'https://admin.ulikechem.com' + v.image" /></router-link></swiper-slide>
          <div class="arrowleft twobtn" slot="button-prev">
            <img src="@/../public/image/向左箭头.png" alt="" />
          </div>
          <div class="arrowright twobtn" slot="button-next">
            <img src="@/../public/image/向右箭头.png" alt="" />
          </div>
        </swiper>
      </div>
      <div class="threefloor">
        <div v-for="(v, i) in products" :key="i + 'mainslot'">
          <mainslot :p="v" v-if="v.goods_list.length"></mainslot>
        </div>
      </div>
      <div class="fourfloor">
        <div>
          <span>PLEASE CONTACT US</span>
          <span>IF YOU NEED ANYTHING</span>
        </div>
        <div>
          <img src="@/../public/image/邮箱.png" />
          <span>Email：</span>
          <span>info@ulikechem.com.cn</span>
        </div>
      </div>
    </div>

    <div class="fivefloor">
      <div><img src="@/../public/image/Snipaste.png" alt="" /></div>
      <div class="from">
        <div>Make A Request</div>
        <div>Procurenment Request</div>
        <div>
          <input type="text" v-model="homefrom.name" placeholder="Product Name" />
          <input type="text" v-model="homefrom.cas_no" placeholder="Cas No" />
          <input type="text" v-model="homefrom.number" placeholder="Quantity (KG)" />
          <input type="text" v-model="homefrom.email" placeholder="Email" />
          <textarea v-model="homefrom.content" rows="6"
            placeholder="Please write down your requirements, we will reply soon."></textarea>
          <input type="button" class="submits" value="Send Request" @click="propose()" />
        </div>
      </div>
    </div>
    <div class="sixfloor contarner">
      <div>
        <span>Our</span>
        <span>Dedicated Services</span>
      </div>
      <div class="sixnav">
        <div>
          We are aiming to support our clients for their greatest success
        </div>
        <div>
          <div class="sixarrowleft">
            <span class="el-icon-arrow-left"></span>
          </div>
          <div class="sixarrowright">
            <span class="el-icon-arrow-right"></span>
          </div>
        </div>
      </div>
      <div class="sixmain">
        <swiper :options="sixswiperOption">
          <swiper-slide class="swiper-no-swiping" v-for="(v, i) in gomchang" :key="i + 'gon'">
            <div @click="
              $router.push('/frontend/about/service?id=' + v.article_id)
              ">
              <div class="imgs">
                <img :src="'https://admin.ulikechem.com' + v.image" />
              </div>
              <div>
                <span>{{ v.name }}</span>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="eightfloor">
      <div>
        <div>
          <div>We Have</div>
          <div>Clients</div>
          <div>To Show!!</div>
        </div>
        <div class="huoban">
          <div>
            <div>
              <div id="num">{{ dibu.PRODUCTS }}+</div>
              <div>Clients</div>
            </div>
            <div>
              <div id="distance">{{ dibu.CLIENTS }}</div>
              <div>Products</div>
            </div>
            <div>
              <div id="capacity">{{ dibu.CAPACITY }}+</div>
              <div>Countries</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sevenfloor contarner">
      <div>
        <div class="sevenleft">
          <img src="@/assets/img/dise.png" />
        </div>
        <div>
          <div>
            <span>We're Dynamic</span><span>Team & Business Expert</span>
          </div>
          <div>
            <span @click="tuandui = true" :class="{ aspan: tuandui == true }">Mission</span>
            <span @click="tuandui = false" :class="{ aspan: tuandui == false }">Vision</span>
          </div>
          <div class="tuand" v-show="!tuandui">
            <div>All for growing</div>
            <div>AARON G.</div>
            <div>Chief Executive Officer</div>
            <div @click="$router.push('/frontend/about/us')">More About Us</div>
            <div><img src="@/../public/image/图层 740.png" alt="" /></div>
          </div>
          <div class="tuand" v-show="tuandui">
            <div>
              Depending on information and technology,<br />
              Support our clients for their greatest success.
            </div>
            <div>AARON G.</div>
            <div>Chief Executive Officer</div>
            <div @click="$router.push('/frontend/about/us')">More About Us</div>
            <div><img src="@/../public/image/图层 740.png" alt="" /></div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="ninefloor">
      <div><span>What</span><span>Client Say</span></div>
      <div>
        <div>
          <div>
            <img src="@/../public/image/left-quote copy.png" />
          </div>
          <div>
            {{dibu.client_request1}}
          </div>
        </div>
        <div>
          <div>
            <img src="@/../public/image/left-quote copy.png" />
          </div>
          <div>
            {{dibu.client_request2}}
          </div>
        </div>
      </div>
    </div> -->

    <div class="message" v-if="mess">
      <div>
        <div>
          <h3>Message</h3>
          <span class="el-icon-close" @click="mess = false"></span>
        </div>
        <div v-if="fail">
          <div><img src="@/../public/image/错误.png" /></div>
          <div>
            <b>{{ messtext }}</b>
            <i>Error</i>
          </div>
        </div>
        <div v-else>
          <div><img src="@/../public/image/wancheng.png" /></div>
          <div>
            <b>Congrats!</b>
            <i>Information Submitted Successfully.</i>
          </div>
        </div>
        <div><span @click="mess = false">OK</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  APIgoodsInfo,
  APIlineChart,
  APIclassif,
  APIfactoryList,
  APIpropose,
  APIconfigInfo,
  getNewsList
} from "@/api/home.js";
import vueSeamlessScroll from "vue-seamless-scroll";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import Mainslot from "./mainslot.vue";

export default {
  components: { swiper, swiperSlide, Mainslot, vueSeamlessScroll },
  data() {
    return {
      // 表单提交信息
      mess: false,
      messtext: "Please fill in the complete information",
      fail: true,
      i: 1,
      tuandui: true,
      time: null,
      nowTime: "",
      title: "For Herbicide TECH",
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      listData: [],
      classOption: {
        step: 0.7,
      },
      swiperOption: {
        autoplay: true,
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        // freeMode: true,
        resistanceRatio: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".arrowright",
          prevEl: ".arrowleft",
          disabledClass: "arrowdis",
        },
      },
      sixswiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: {
          delay: 3000, //1秒切换一次
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".sixarrowright",
          prevEl: ".sixarrowleft",
          disabledClass: "sixarrow",
        },
      },
      products: [],
      //工厂swiepr
      gomchang: [],
      //广告
      guangao: [],
      //首页表单form
      homefrom: {
        name: "",
        number: "",
        cas_no: "",
        email: "",
        content: "",
      },
      //底部数字
      dibu: {},
      //曲线数据
      quxian: [],
      usd: 7.1,

      /* 新闻列表 */
      newsList: [],

      hhh: 0,
    };
  },
  created() {
    this.GoodsInfo();
    this.lineChart();
    this.classif();
    this.factoryList();
    this.configInfo();
    this.getHomeNews();
  },
  mounted() {
    this.getusd();
  },
  methods: {
    // 一楼echars
    ficat() {
      this.time = setInterval(() => {
        this.i++;
        if (this.i > 3) {
          this.i = 1;
        }
      }, 5000);
    },
    // echars初始化
    getcharts(dom, X, Jia) {
      let chart = dom;
      let option = {
        title: {
          x: "left",
          text: "",
          textStyle: {
            color: "#282A2A",
            fontSize: "20",
            fontWeight: "bold",
          },
        },
        grid: {
          left: 50,
          right: 50,
          bottom: 30,
        },
        xAxis: {
          type: "category",
          data: X,
          nameTextStyle: {
            align: "left",
            borderType: "dotted",
          },
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: {
            show: true,
          },
          splitLine: {
            lineStyle: {
              color: "#012f4a",
            },
            type: "solid",
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
          },
        },
        series: [
          {
            name: "$",
            data: Jia,
            type: "line",
            smooth: true,
            showSymbol: true, //是否默认展示圆点
            symbol: "circle",
            symbolSize: 8,
          },
        ],
        tooltip: {
          show: true, //---是否显示提示框,默认为true
          trigger: "axis", //---数据项图形触发
          axisPointer: {
            //---指示样式
            type: "line",
            axis: "auto",
            backgroundColor: "#edeff1",
            label: {
              show: true,
              backgroundColor: "#eef0f2",
              color: "#a6a4a7",
              borderColor: "#a0a6a7",
            },
          },
          formatter: function (params) {
            let listparams = [];
            let list = "";
            listparams.push(
              `<span style="background:#eceff1;display:block;position:relative;padding:2px;padding-left:25px;"><i style="position:absolute;top:50%;left:10px;width: 10px;height: 10px;border-radius: 50%;background: #3e67d1;transform: translateY(-50%);"></i>${params[0].name}</span>`
            );
            listparams.push(
              `<span style="padding:5px 10px;display:block;">FOB $${params[0].data}/kg</span>`
            );
            list = listparams.join("");
            return (
              '<div class="showBox" style="text-align:center">' +
              list +
              "</div>"
            );
          },
          padding: 0,
          textStyle: {
            //---提示框内容样式
            color: "#737574",
          },
          borderWidth: 0,
        },
      };
      if (chart) {
        let myChart = this.$echarts.init(chart);
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    // 人民币美元汇率
    getusd() {
      this.$axios({
        url: "https://api.exchangerate-api.com/v4/latest/USD",
        method: "GET",
      }).then((res) => {
        this.usd = res.data.rates.CNY;
      });
    },
    // 数字增加动画
    numadd(num, distance, capacity) {
      numScroll("num", Number(num), 2000);
      numScroll("distance", Number(distance), 2000, true);
      numScroll("capacity", Number(capacity), 2000, true);
      function numScroll(id, maxNum, time, jia = false) {
        var numDom = document.getElementById(id);
        var numInit = 0;
        var addNum = maxNum / (time / 10);
        var minTime = time / maxNum;
        var t = setInterval(function () {
          if (numInit >= maxNum) {
            clearInterval(t);
            100000;
            if (maxNum > 99999) {
              maxNum = Math.floor(maxNum / 10000) + "," + (maxNum % 10000);
            }
            numDom.innerText = maxNum + (jia ? "+" : "+");
          } else {
            numInit += addNum;
            numDom.innerText = Math.round(numInit) + (jia ? "+" : "+");
          }
        }, 10);
      }
    },
    //首页曲线图
    async lineChart() {
      let res = await APIlineChart();
      if (res.status === 200) {
        let Echar = this.$refs.Echar;
        this.quxian = res.data;
        let Data = res.data;
        Data.forEach((v, i) => {
          let X = ["0", "0", "0", "0", "0"];
          let Jia = ["0", "0", "0", "0", "0"];
          if (v.history_price.length > 0) {
            X = v.history_price.map((x) => {
              return x.english_time ? x.english_time : "0";
            });
            Jia = v.history_price.map((x) => {
              return x.history_price;
            });
          }
          this.getcharts(Echar[i], X, Jia);
        });
        this.ficat();
      }
    },
    //向上滚动接口
    async GoodsInfo() {
      let res = await APIgoodsInfo({ page: "", limit: "" });
      if (res.status === 200) {
        this.listData = res.data;
      }
    },
    //首页分类商品
    async classif() {
      let res = await APIclassif({ limit: "", page: "" });
      if (res.status === 200) {
        this.products = res.data;
      }
    },
    //表单提交
    async propose() {
      //数字这则
      this.mess = true;
      let num = /^([1-9][0-9]*)$/;
      let from = { ...this.homefrom };
      if (
        from.name &&
        from.number &&
        from.cas_no &&
        from.email &&
        from.content
      ) {
        if (num.test(from.number)) {
          this.mess = false;
          let res = await APIpropose({ ...from });
          this.mess = true;
          if (res.status === 200) {
            this.fail = false;
            this.homefrom = {
              name: "",
              number: "",
              cas_no: "",
              email: "",
              content: "",
            };
          }
        } else {
          this.messtext = "Quantity Incorrect format";
          this.fail = true;
        }
      } else {
        this.messtext = "Please fill in the complete information";
        this.fail = true;
      }
    },
    // 工厂-广告
    async factoryList() {
      let res = await APIfactoryList();
      if (res.status === 200) {
        this.gomchang = res.data.result;
        this.guangao = res.data.images;
      }
    },
    //底部数字-数据
    async configInfo() {
      let res = await APIconfigInfo();
      if (res.status === 200) {
        this.dibu = res.data;
        this.numadd(res.data.CLIENTS, res.data.PRODUCTS, res.data.CAPACITY);
      }
    },

    /* 获取新闻 */
    async getHomeNews() {
      const res = await getNewsList({ page: 1 });
      this.newsList = res.data.res.list;

      this.$nextTick(() => {
        this.hhh = document.querySelector(".onefloor-left").clientHeight - document.querySelector(".rightop").clientHeight;
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.time);
  },
};
</script>

<style lang="scss" scoped>
.newss_warp {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .more {
    color: #3e67d1;
  }
}

.echarsa {
  position: relative;

  .echarsa-tiem {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    visibility: hidden;
  }

  .echarsa-tiem-on {
    position: relative;
    visibility: visible;
  }
}

.new_list {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: stretch;

  a {
    // display: flex;
    // flex-direction: column;
    // align-items: flex-start;
    padding-bottom: 10px;
    gap: 10px;
    border-bottom: 1px solid #f1f1f1;

    .span {
      color: #3e67d1;
      text-align: left;
    }

    .text {
      text-align: start;
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      h6 {
        text-align: start;
        font-size: 18px;
        display: inline;
      }

      span {
        display: inline;
        font-size: 16px;
        color: #999;
        font-family: 800;
        white-space: nowrap;
        margin-left: 10px;
      }
    }
  }
}

.sxl_tis {
  font-size: 32px;
  display: flex;
  // justify-content: space-between;
  align-items: center;

  &::before {
    content: "";
    width: 5px;
    height: 25px;
    margin-right: 5px;
    background: #3e67d1;
  }
}

.main {
  margin-top: 48px;

  >div {
    margin: 0 auto;
  }

  .onefloor {
    background: #fcfefe;
    box-shadow: 1px 2px 23px 6px rgba(66, 66, 66, 0.09);
    border-radius: 19px;
    // width: 95%;
    padding: 0 54px;
    display: flex;
    align-items: stretch;

    // justify-content: space-between;
    .onefloor-left {
      width: 50%;
      border-right: 1px solid #cdcdcd;
      padding-top: 59px;
      padding-right: 5rem;

      .rate {
        color: #282a2a;
        font-size: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        >div:nth-child(1)::before {
          content: "";
          clear: both;
          display: inline-block;
          width: 5px;
          height: 25px;
          margin-right: 5px;
          background: #3e67d1;
        }

        .dateday {
          font-size: 18px;
        }
      }

      .usd {
        padding: 13px 0;
        text-align: center;
        border: 1px solid #052436;
        margin-top: 12px;
        color: #3e67d1;
        font-size: 20px;
      }

      .ification {
        display: flex;
        justify-content: space-between;
        margin-top: 50px;

        >span {
          padding: 12px 20px;
        }

        >.ficat {
          background-color: #3e67d1;
          color: #fff;
        }
      }

      .echar {
        width: 100%;
        height: 275px;
        margin-top: -26px;
      }

      >div:last-child {
        text-align: center;
        font-size: 18px;
        color: #282a2a;
      }
    }

    .onefloor-right {
      width: 50%;
      padding: 26px 20px;

      .rightop {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #adadad;

        .name {
          flex: 2;
          padding-right: 10px;
        }

        .price {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .trend {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 10px;
        }

        span {
          width: 100%;
          color: #fcfefe;
          background-color: #3e67d1;
          text-align: center;
          padding: 10px 20px;
          display: inline-block;
        }
      }

      .rightmain {
        overflow: hidden;
        height: 1000px;

        // height: 100%;
        // position: relative;
        li {
          display: flex;
          align-items: center;
          padding: 10px 0;
          border-bottom: 1px solid #adadad;

          >div:last-child {
            padding-right: 20px;
            color: #00a190;
          }

          >div:first-child {
            >div:last-child {
              font-size: 12px;
              color: #3e67d1;
              text-align: center;
            }
          }
        }

        .names {
          padding-right: 10px;
          flex: 2;

          &> :nth-child(1) {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          &> :nth-child(2) {
            text-align: left !important;
          }
        }

        .jiage {
          flex: 1;
          text-align: center;
        }

        .bili {
          flex: 1;
          padding: 0 !important;
          text-align: center;
          padding-left: 10px;

          &>img {
            width: 26px;
          }
        }
      }
    }
  }

  .twofloor {
    text-align: center;
    margin-top: 74px;
    position: relative;

    img {
      height: 100%;
      object-fit: cover;
      width: 100%;
      display: block;
      height: 200px;
    }

    a {
      height: 100%;

      display: block;
    }

    .twobtn {
      width: 30px;
      height: 50px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 111;
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;

      &.arrowright {
        right: 0;
      }

      &.arrowleft {
        left: 0;
      }

      img {
        width: 80%;
        height: 80%;
        object-fit: contain;
        min-height: auto;
      }
    }
  }

  .fourfloor {
    text-align: center;
    margin-top: 150px;

    >div:first-child {
      font-size: 48px;
      margin-bottom: 35px;

      >span:first-child {
        margin-right: 10px;
        color: #3f63eb;
        font-weight: bold;
      }

      >span:last-child {
        color: #052535;
        font-style: italic;
      }
    }

    >div:last-child {
      border: 2px solid #3f63eb;
      color: #3f63eb;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      width: 50%;
      padding: 15px 23px;
      margin: 0 auto;

      >img {
        vertical-align: middle;
        width: 60px;
        margin-right: 20px;
      }
    }
  }
}

.fivefloor {
  display: flex;
  // height: 600px;
  margin-top: 95px;

  >div {
    width: 50%;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .from {
    padding: 50px 80px;
    background-color: #052535;
    background-image: url("@/../public/image/GettyImages.480374488.high_res_comp.png");
    background-position-x: 20%;

    >div:first-child {
      color: #ffffff;
      font-size: 18px;
      opacity: 0.5;
      margin-bottom: 10px;
      margin-left: -6px;
    }

    >div:nth-child(2) {
      font-size: 40px;
      color: #ffffff;
      margin-bottom: 20px;
    }

    >div:nth-child(3) {
      width: 80%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      input[type="text"],
      textarea {
        color: #f9fafb;
        width: 48%;
        border: 2px solid rgba(255, 255, 255, 0.1);
        background: transparent;
        padding: 20px;
        margin-bottom: 20px;
      }

      input[type="text"]::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #999;
      }

      input[placeholder="KG"]::-webkit-input-placeholder {
        color: #f9fafb;
      }

      textarea {
        width: 100%;
        resize: none;
        font-size: 14px;
        font-family: Arial;
      }

      .submits {
        color: #fff;
        width: 100%;
        font-size: 16px;
        padding: 20px 0;
        background-color: #3f63eb;
      }
    }
  }
}

.sixfloor {
  margin-top: 100px;

  >div:first-child {
    font-size: 48px;
    color: #26447b;
    font-weight: 900;

    >span:first-child {
      color: #4066d3;
      margin-right: 18px;
      font-weight: normal;
    }
  }

  .sixnav {
    color: #333333;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;

    >div:nth-child(2) {
      display: flex;

      >div {
        border: 1px solid #26447b;
        width: 35px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        margin-right: 5px;

        >span {
          color: #26447b;
        }
      }

      >.sixarrow {
        opacity: 0.3;
      }
    }
  }

  .sixmain {
    // width: 95%;
    margin: 0 auto;
    margin-top: 50px;

    div {
      font-size: 24px;
      font-weight: bold;
      text-align: center;

      .imgs {
        height: 350px;

        &>img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      >span:first-child {
        color: #26447a;
      }
    }
  }
}

.sevenfloor {
  position: relative;
  margin-top: 100px;
  margin-bottom: 129px;

  >div {
    // width: 95%;
    // margin: 0 auto;
    display: flex;

    >div {
      width: 50%;
      height: 100%;
    }

    >.sevenleft {
      width: 100%;
      position: relative;
      z-index: 10;

      img {
        width: 100%;
      }
    }

    >div:nth-child(2) {
      position: absolute;
      right: 0;
      z-index: 11;
      color: #fff;
      padding: 60px 40px;
      padding-left: 0;

      >div:nth-child(1) {
        font-size: 56px;
        line-height: 90px;
        background-color: #303030;
        padding-bottom: 100px;
        padding-right: 50px;

        >span:nth-child(2) {
          font-weight: bold;
          margin-left: 30px;
        }
      }

      >div:nth-child(2) {
        background-color: #303030;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 7%;

        >span {
          font-weight: normal;
          color: #c9c9c9;
          margin-right: 40px;
          margin-bottom: 10px;
        }

        .aspan {
          font-weight: bold;
          color: #fff;
        }
      }

      .tuand {
        position: relative;
        color: #f6f6f6;

        >div:nth-child(1) {
          height: 30px;
        }

        >div:nth-child(2) {
          font-weight: bold;
          font-size: 25px;
          margin-top: 7%;
        }

        >div:nth-child(3) {
          font-size: 20px;
          color: #9e9e9e;
          margin-bottom: 16%;
          padding-top: 4px;
        }

        >div:nth-child(4) {
          padding: 20px;
          border: 2px solid #fff;
          width: 30%;
          text-align: center;
          z-index: 1;
          position: relative;
        }

        >div:nth-child(5) {
          position: absolute;
          bottom: 20px;
          left: 100%;
          transform: translateX(-160%);
          z-index: -1;
        }
      }
    }
  }
}

.eightfloor {
  margin-top: 5rem;
  background: #052535;
  color: #ffffff;
  background-image: url("@/../public/image/Layer\ 605.png");

  >div {
    width: 60%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 80px 0;

    >div:nth-child(1) {
      // width: 25%;
      text-align: end;
      font-size: 40px;
      line-height: 55px;
      margin-right: 100px;

      >div:nth-child(2),
      div:nth-child(3) {
        font-size: 48px;
        font-weight: bold;
      }
    }

    .huoban {
      width: 65%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      >div:first-child {
        display: flex;
        justify-content: space-between;

        >div {
          font-weight: bold;
          text-align: center;

          >div:first-child {
            font-size: 40px;
          }

          >div:nth-child(2) {
            font-size: 15px;
          }
        }
      }

      >div:nth-child(2) {
        font-size: 17px;

        >span:nth-child(odd) {
          color: #3f63eb;
        }
      }
    }
  }
}

.ninefloor {
  width: 65%;
  margin: 0 auto;
  text-align: center;

  >div:first-child {
    margin-top: 80px;
    color: #4066d3;
    font-size: 48px;

    >span:nth-child(2) {
      font-size: 50px;
      font-weight: bold;
      margin-left: 15px;
    }
  }

  >div:nth-child(2) {
    display: flex;
    justify-content: space-between;
    margin-top: 60px;

    >div {
      width: 45%;
      display: flex;
      text-align: left;
      font-size: 20px;
      border: 1px solid #f8f6f6;
      padding: 50px 30px;
      background: #ffffff;

      >div:first-child {
        margin-right: 20px;
      }
    }
  }

  >div:nth-child(3) {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    text-align: end;
    line-height: 50px;

    >div:first-child {
      color: #26447b;
      font-size: 40px;

      >div:last-child {
        font-weight: bold;
      }
    }

    >div:not(:first-child) {
      opacity: 0.1;
      margin-left: 35px;
      padding: 25px 60px;
      border: 1px solid #000000;
    }
  }
}

.message {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;

  >div {
    background: #ffffff;
    width: 600px;

    >div {
      background: #f4f4f4;
      display: flex;
      align-items: center;
    }

    >div:first-child {
      justify-content: space-between;
      padding: 15px;
      padding-left: 30px;

      >h3 {
        font-size: 16px;
      }
    }

    >div:last-child {
      padding: 15px 0;
      justify-content: center;

      >span {
        text-align: center;
        background: #4066d3;
        color: #fff;
        padding: 7px 50px;
        border-radius: 3px;
      }
    }

    >div:nth-child(2) {
      background: #fff;
      padding: 80px;

      >div:last-child {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 30px;

        b {
          font-weight: normal;
          font-size: 24px;
        }

        i {
          font-style: normal;
          color: #999999;
        }
      }
    }
  }
}

// @media screen and (max-width: 1600px) {
//   .com-header .onehead a {
//     font-style: 35px;
//   }
//   .com-header .onehead .inp {
//     width: 498px;
//   }
//   .sixfloor .sixmain > div > div:nth-child(2) {
//     font-size: 1.2rem;
//   }
//   .sevenfloor > div > div:nth-child(2) > div:nth-child(1) {
//     font-size: 50px;
//     padding-bottom: 50px;
//   }
//   .sevenfloor > div > div:nth-child(2) > div:nth-child(2) {
//     margin-bottom: 30px;
//   }
//   .eightfloor > div > div:nth-child(1) {
//     font-size: 30px;
//   }
//   .eightfloor > div > div:nth-child(1) > div:nth-child(2) {
//     font-size: 38px;
//   }
// }
// @media screen and (max-width: 1280px) {
//   .main .onefloor .onefloor-left .ification > span {
//     padding: 12px 10px;
//   }
//   .main .onefloor .onefloor-left > div:last-child {
//     font-size: 16px;
//   }
//   .sevenfloor > div > div:nth-child(2) > div:nth-child(1) {
//     font-size: 30px;
//     padding-bottom: 20px;
//     line-height: 48px;
//     display: flex;
//     flex-direction: column;
//   }
//   .sevenfloor > div > div:nth-child(2) > div:nth-child(2){
//     margin-bottom: 20px;
//   }
//   .sevenfloor > div > div:nth-child(2) > div:nth-child(1) > span:nth-child(2){
//     margin-left: 0;
//   }
//   .sevenfloor > div > div:nth-child(2) {
//     padding: 30px;
//     right: 15px;
//   }
//   .sevenfloor > div > div:nth-child(2) .tuand > div:nth-child(2) {
//     margin-top: 20px;
//   }
//   .sevenfloor > div > div:nth-child(2) .tuand > div:nth-child(5) {
//     right: 0;
//   }
//   .sevenfloor > div > div:nth-child(2) .tuand > div:nth-child(4) {
//     padding: 15px;
//     width: 35%;
//   }
//   .sevenfloor > div > div:nth-child(2) .tuand > div:nth-child(3) {
//     margin-bottom: 30px;
//   }
//   .eightfloor > div > div:nth-child(1) {
//     width: 30%;
//   }
//   .eightfloor > div .huoban > div:nth-child(2) {
//     font-size: 14px;
//   }
//   .ninefloor > div:nth-child(3) > div:first-child {
//     font-size: 30px;
//   }
//   .main .fourfloor > div:first-child {
//     font-size: 34px;
//   }
//   .main .fourfloor > div:last-child{
//     font-size: 20px;
//   }
// }
// @media screen and (max-width: 1024px) {
//   .main .onefloor .onefloor-left .rate {
//     flex-direction: column;
//   }
//   .main .onefloor {
//     padding: 0 20px;
//   }
//   .main .onefloor .onefloor-left {
//     padding-right: 2rem;
//   }
//   .main .onefloor .onefloor-left > div:last-child {
//     font-size: 15px;
//   }
//   .main .twofloor {
//     width: 90%;
//   }
//   .main .fourfloor > div:last-child {
//     font-size: 20px;
//   }
//   .main .fourfloor > div:first-child {
//     font-size: 30px;
//   }
//   .fivefloor .from > div:nth-child(2) {
//     font-size: 25px;
//   }
//   .sevenfloor > div > div:nth-child(2) > div:nth-child(1) {
//     font-size: 30px;
//     line-height: 1.5;
//     padding-bottom: 20px;
//   }
//   .sevenfloor > div > div:nth-child(2) > div:nth-child(2) {
//     margin-bottom: 20px;
//   }
//   .sevenfloor > div > div:nth-child(2) .tuand > div:nth-child(5) {
//     right: 20px;
//   }
//   .sevenfloor > div > div:nth-child(2) .tuand > div:nth-child(3) {
//     margin-bottom: 15px;
//   }
//   .sevenfloor > div > div:nth-child(2) .tuand > div:nth-child(4) {
//     width: 50%;
//   }
//   .sevenfloor > div > div:nth-child(2) .tuand > div:nth-child(2) {
//     margin-top: 15px;
//   }
//   .eightfloor > div {
//     width: 65%;
//   }
//   .ninefloor > div:nth-child(2) > div {
//     font-size: 15px;
//   }
//   .ninefloor > div:nth-child(3) > div:first-child > div:last-child {
//     white-space: nowrap;
//   }
// }
@media screen and (max-width: 912px) {
  .sevenfloor>div>div:nth-child(2)>div:nth-child(1) {
    font-size: 25px;

    span {
      display: block;
    }

    >span:last-child {
      margin-left: 0;
    }
  }

  .sevenfloor>div>div:nth-child(2) {
    padding: 25px;
  }

  .sevenfloor>div>div:nth-child(2) .tuand>div:nth-child(2) {
    font-size: 20px;
  }

  .sevenfloor>div>div:nth-child(2) .tuand>div:nth-child(3) {
    margin-bottom: 5px;
  }

  .sevenfloor>div>div:nth-child(2) .tuand>div:nth-child(4) {
    padding: 10px;
  }

  .eightfloor>div>div:nth-child(1)>div:nth-child(2) {
    font-size: 35px;
  }

  .eightfloor>div {
    width: 72%;
  }

  .ninefloor>div:nth-child(2)>div {
    padding: 0;
  }
}

@media screen and (max-width: 400px) {
  .main .onefloor>div {
    width: 100% !important;
  }

  .main .onefloor {
    width: 100%;
    flex-direction: column;
  }

  .main .onefloor .onefloor-left {
    padding: 0;
    border: 0;
    padding-top: 20px;
  }

  .main .onefloor .onefloor-right {
    padding: 20px 0;
  }

  .main .onefloor .onefloor-left .ification>span {
    padding: 12px 3px;
  }

  .main .onefloor .onefloor-right .rightmain {
    height: 300px;
  }

  .main .twofloor {
    margin-top: 30px;
  }

  .main .fourfloor>div:first-child {
    display: flex;
    flex-direction: column;
    font-size: 25px;
  }

  .main .fourfloor>div:last-child {
    width: 100%;
    font-size: 15px;
  }

  .main .fourfloor>div:last-child>img {
    // display: block;
    width: 30px;
  }

  .fivefloor>div:first-child {
    display: none;
  }

  .fivefloor .from {
    width: 100%;
    padding: 50px 40px;
  }

  .fivefloor .from>div:nth-child(3) {
    width: 100%;
  }

  .sixfloor>div:first-child {
    font-size: 33px;
  }

  .sixfloor .sixnav {
    font-size: 15px;
  }

  .sixfloor .sixnav>div:first-child {
    width: 70%;
  }

  .sixfloor .sixmain {
    flex-direction: column;
  }

  .sixfloor .sixmain>div {
    width: 100%;
    margin-bottom: 20px;
  }

  .sixfloor .sixmain>div>div:nth-child(2) {
    margin-top: 0;
    font-size: 20px;
  }

  .sevenfloor {
    display: none;
  }

  .eightfloor>div {
    flex-direction: column;
  }

  .eightfloor>div>div:nth-child(1) {
    width: 100%;
    text-align: center;
  }

  .eightfloor>div>div:nth-child(1)>div:nth-child(2) {
    font-size: 28px;
  }

  .eightfloor>div .huoban {
    width: 100%;
    margin-top: 20px;
  }

  .eightfloor>div .huoban>div:first-child {
    flex-direction: column;
  }

  .eightfloor>div .huoban>div:first-child>div {
    display: flex;
    justify-content: space-between;
  }

  .eightfloor>div .huoban>div:first-child>div>div:nth-child(2) {
    width: 80px;
  }

  .ninefloor>div:nth-child(3) {
    flex-direction: column;
  }

  .ninefloor>div:nth-child(3)>div:not(:first-child) {
    margin-right: 0;
  }

  .ninefloor>div:first-child {
    font-size: 30px;
  }

  .ninefloor>div:first-child>span:nth-child(2) {
    font-size: 30px;
  }

  .ninefloor>div:nth-child(2) {
    flex-direction: column;
  }

  .ninefloor>div:nth-child(2)>div {
    width: 100%;
  }
}
</style>
